function replaceTenantId (tenantId: string) {
  return tenantId.replace("_onprem", "");
}

export default replaceTenantId;
